import { render } from "./CertificateSection.vue?vue&type=template&id=10312503&scoped=true"
import script from "./CertificateSection.vue?vue&type=script&lang=js"
export * from "./CertificateSection.vue?vue&type=script&lang=js"

import "./CertificateSection.vue?vue&type=style&index=0&id=10312503&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10312503"]])

export default __exports__